import { COUNTRIES } from '@config/constants'

export const E_WASTE_LINK = {
  [COUNTRIES.FR]: true,
  [COUNTRIES.DE]: true,
  [COUNTRIES.GB]: true,
  [COUNTRIES.US]: true,
}
